import React, { useState } from 'react';
import { IconButton, Typography } from 'seagull';
import { Close14, WideArrowBackward, WideArrowForward } from 'seagull/icons';
import styles from "./SeeWhatItsLike.module.scss";

const handleIndexChange = (newIndex, totalItems) => {
  if (newIndex >= totalItems) return 0;
  if (newIndex < 0) return totalItems - 1;
  return newIndex;
};

export default function Modal(_ref) {
  let {
    steps,
    testPrefix,
    onClose
  } = _ref;
  const [currentIndex, setCurrentIndex] = useState(0);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.modalRoot
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: styles.closeButton,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Close14, null)), /*#__PURE__*/React.createElement(IconButton, {
    "data-testid": "".concat(testPrefix, "-btn-back"),
    className: styles.arrowBackward,
    onClick: () => {
      setCurrentIndex(handleIndexChange(currentIndex - 1, steps.length));
    }
  }, /*#__PURE__*/React.createElement(WideArrowBackward, null)), steps.map((_ref2, idx) => {
    let {
      title,
      subtitle,
      image: {
        src,
        altText,
        width,
        height
      }
    } = _ref2;
    return /*#__PURE__*/React.createElement("figure", {
      key: src,
      className: styles.figure
    }, /*#__PURE__*/React.createElement("img", {
      style: {
        opacity: currentIndex === idx ? 1 : 0
      },
      src: src,
      alt: altText,
      "data-testid": currentIndex === idx ? "".concat(testPrefix, "-img") : undefined,
      "aria-hidden": currentIndex !== idx,
      width: width,
      height: height
    }), /*#__PURE__*/React.createElement("figcaption", {
      className: styles.caption,
      style: {
        visibility: currentIndex === idx ? 'visible' : 'hidden'
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      as: "p",
      "data-testid": currentIndex === idx ? "".concat(testPrefix, "-title") : undefined,
      variant: "h5",
      skin: "invertedStandard"
    }, title), typeof subtitle === 'string' ? /*#__PURE__*/React.createElement(Typography, {
      as: "p",
      "data-testid": currentIndex === idx ? "".concat(testPrefix, "-subtitle") : undefined,
      skin: "invertedStandard"
    }, subtitle) : /*#__PURE__*/React.createElement("div", {
      "data-testid": currentIndex === idx ? "".concat(testPrefix, "-subtitle") : undefined
    }, subtitle)), /*#__PURE__*/React.createElement(Typography, {
      className: styles.counter,
      "data-testid": currentIndex === idx ? "".concat(testPrefix, "-counter") : undefined,
      skin: "invertedStandard"
    }, currentIndex + 1, "/", steps.length)));
  }), /*#__PURE__*/React.createElement(IconButton, {
    "data-testid": "".concat(testPrefix, "-btn-forward"),
    className: styles.arrowForward,
    onClick: () => {
      setCurrentIndex(handleIndexChange(currentIndex + 1, steps.length));
    }
  }, /*#__PURE__*/React.createElement(WideArrowForward, null)));
}